export const formatTime = (time: string) => {
  let hour = time.substring(0, 2);
  const minute = time.substring(3, 5);
  const amPm = Number(hour) < 12 ? "am" : "pm";

  if (hour[0] === "0") {
    hour = hour[1];
  }

  return `${hour}:${minute} ${amPm}`;
};
